import React from 'react'
import {Box, Link, Typography} from '@material-ui/core'

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.untsystem.edu/">
                UNT SYSTEM
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    )
}

const Footer = () => (
    <Box style={{marginTop: '1rem', marginBottom: '1rem'}}>
        <Typography align="center" variant="body2" color="inherit">
            <Link href="http://www.unt.edu/disclaimer.htm">Disclaimer</Link> |{' '}
            <Link href="http://www.unt.edu/ada.htm">AA/EOE/ADA</Link> |{' '}
            <Link href="http://www.unt.edu/unt_ps.html">Privacy </Link> |{' '}
            <Link href="http://policy.unt.edu/policy-by-number/5">
                Electronic Accessibility
            </Link>{' '}
            |{' '}
            <Link href="https://www.unt.edu/required-links">
                Required Links
            </Link>
        </Typography>
        <Copyright />
    </Box>
)

export default Footer
